(function () {
  'use strict';

  var supportPageOffset = window.pageXOffset !== undefined;
  var isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

  function collectProductItems(grid) {
    if (!grid) return [];
    var scoped = grid.querySelectorAll(':scope > .collection__product');
    if (scoped.length) return Array.prototype.slice.call(scoped);
    return Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.nodeType === 1;
    });
  }

  function appendProductNodes(grid, nextGrid) {
    var nodes = collectProductItems(nextGrid);
    var fragment = document.createDocumentFragment();
    nodes.forEach(function (node) {
      fragment.appendChild(node);
    });
    var firstNew = fragment.firstElementChild;
    grid.appendChild(fragment);
    return { appended: nodes, firstNew: firstNew };
  }

  function revealLoadedProduct(el) {
    if (!el || !el.classList) return;
    el.classList.add('aos-init', 'aos-animate');
    el.querySelectorAll('[data-aos]').forEach(function (node) {
      node.classList.add('aos-init', 'aos-animate');
    });
  }

  function headerHeight() {
    var header = document.querySelector('#shopify-header-section');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function shouldScrollToNewProduct(rect, headerH, viewportHeight) {
    if (!rect) return false;
    return rect.top < headerH + 8 || rect.top > viewportHeight - 80;
  }

  class LoadProducts extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('#loadMoreProducts');
      if (!this.button) return;

      this.style.overflowAnchor = 'none';
      this.button.style.overflowAnchor = 'none';

      var mode = this.button.getAttribute('data-scroll');
      if (mode === 'button') {
        this.button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          this.loadProducts();
        }.bind(this));
      } else if (mode === 'scroll') {
        window.addEventListener('scroll', theme.utils.throttle(this.startLoading.bind(this), 1000));
      }
    }

    startLoading() {
      if (!this.button || this.button.getAttribute('data-over') === 'true') return;

      var loadedEl = this.querySelector('.products_loaded');
      if (!loadedEl || !theme.utils.offset) return;

      var scrollTop = supportPageOffset
        ? window.pageYOffset
        : (isCSS1Compat ? document.documentElement : document.body).scrollTop;
      var triggerY = theme.utils.offset(loadedEl).top - document.documentElement.clientHeight / 2;

      if (scrollTop + document.documentElement.clientHeight >= triggerY) {
        this.loadProducts();
      }
    }

    loadProducts() {
      if (!this.button || this.button.getAttribute('data-over') === 'true') return;
      if (this._loading) return;

      var href = this.button.getAttribute('href');
      if (!href) return;

      var section = this.closest('section');
      if (!section) return;

      this.productGrid = section.querySelector('#main-collection-product-grid');
      if (!this.productGrid) return;

      this.loader = this.querySelector('.loader');
      this.productsLoadedBarFill = this.querySelector('.prodcuts_loaded_fill');
      this.productsLoaded = document.querySelectorAll('span.products_loaded_count');

      this._loading = true;
      if (this.loader) this.loader.classList.remove('hide');
      if (this.button.getAttribute('data-scroll') === 'button') {
        this.button.classList.add('hide');
      }

      var self = this;
      window
        .ajaxURL(href)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('#main-collection-product-grid');
          if (!nextGrid) {
            self._finishLoading(true);
            return;
          }

          var appended = appendProductNodes(self.productGrid, nextGrid);
          appended.appended.forEach(revealLoadedProduct);

          var loadedSource = doc.querySelector('[data-loaded]');
          if (loadedSource) {
            self.productsLoaded.forEach(function (el) {
              el.innerHTML = loadedSource.getAttribute('data-loaded');
            });

            var totalEl = doc.querySelector('[data-products]');
            if (self.productsLoadedBarFill && totalEl) {
              var loaded = parseInt(loadedSource.getAttribute('data-loaded'), 10) || 0;
              var total = parseInt(totalEl.getAttribute('data-products'), 10) || 0;
              if (total > 0) {
                self.productsLoadedBarFill.style.width = Math.round((100 * loaded) / total) + '%';
              }
            }
          }

          var nextBtn = doc.querySelector('#loadMoreProducts');
          if (nextBtn && nextBtn.getAttribute('href')) {
            self.button.setAttribute('href', nextBtn.getAttribute('href'));
            if (self.button.getAttribute('data-scroll') === 'button') {
              self.button.classList.remove('hide');
            }
          } else {
            self.button.classList.add('hide');
            self.button.setAttribute('data-over', 'true');
          }

          appended.appended.forEach(function (item) {
            item.querySelectorAll('img, svg').forEach(function (el) {
              if (theme.utils.lazyBackgroundObserver) {
                theme.utils.lazyBackgroundObserver.observe(el);
              }
            });
          });

          var layoutEl = document.querySelector('collection-layout');
          if (layoutEl) {
            var active = layoutEl.querySelector('[data-layout].active');
            if (active) {
              var layoutClass = active.getAttribute('data-layout');
              appended.appended.forEach(function (item) {
                item.className = 'flex__item collection__product aos-init aos-animate ' + layoutClass;
              });
            }
          }

          self._finishLoading(false);
          self._revealNewProducts(appended.firstNew);
        })
        .catch(function () {
          self._finishLoading(true);
        });
    }

    _revealNewProducts(firstNew) {
      if (!firstNew) return;

      var run = function () {
        var rect = firstNew.getBoundingClientRect();
        var headerH = headerHeight();
        if (!shouldScrollToNewProduct(rect, headerH, window.innerHeight)) return;
        var top = Math.max(0, window.scrollY + rect.top - headerH - 16);
        window.scrollTo({ top: top, behavior: 'smooth' });
      };

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
    }

    _finishLoading(restoreButton) {
      this._loading = false;
      if (this.loader) this.loader.classList.add('hide');
      if (restoreButton && this.button && this.button.getAttribute('data-scroll') === 'button') {
        this.button.classList.remove('hide');
      }
    }
  }

  class CollectionLayout extends HTMLElement {
    connectedCallback() {
      var toggles = this.querySelectorAll('div[data-layout]');
      var section = this.closest('.main-collection');
      if (!section || !toggles.length) return;

      var activeToggle = null;
      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          var products = section.querySelectorAll('.collection__product');
          var layout = this.getAttribute('data-layout');
          this.classList.toggle('active');
          if (activeToggle) activeToggle.classList.toggle('active');
          activeToggle = this;
          products.forEach(function (product) {
            product.className = 'flex__item collection__product aos-init aos-animate ' + layout;
          });
        });
      });
    }
  }

  if (!customElements.get('load-products')) {
    customElements.define('load-products', LoadProducts);
  }
  if (!customElements.get('collection-layout')) {
    customElements.define('collection-layout', CollectionLayout);
  }
})();
